import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import BrandLogo from '../../../../assets/images/payu_logo_white.svg';
class HeaderOnboarding extends React.Component {
  render(){
    return(
      <div>
      <header>
        <div className="main-topheader colorizeX fixed">
          <div className="container">
            <div className="row">
              <div className="col-md-12 clearfix">
                <a href="/" title="PayU" className="main-logo">
                  <BrandLogo className="float-left" height='32'/>
                </a>
                <ul className="top-nav faq-nav pull-right clearfix list-inline hdr-right-icon">
                  <li><a href="https://www.payumoney.com/payment-gateway-feature.html">Features</a></li>
                  <li><a href="https://www.payumoney.com/payment-gateway-fee.html">Pricing</a></li>
                  <li><a href="https://developer.payumoney.com/">Developers</a></li>
                  <li><Link to="/faqs">Get Help</Link></li>
                  <li className="login-btn first small"><Link to="/">Log in</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>

    );
  }
}
export default HeaderOnboarding